export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail oder Benutzername',
      invalidEmailOrUsername: 'Ungültige E-mail oder Benutzername',
      invalidPassword: 'Ungültiges Passwort',
      logInToPlanka: 'Einloggen',
      noInternetConnection: 'Keine Internetverbindung',
      pageNotFound_title: 'Seite nicht gefunden',
      password: 'Passwort',
      projectManagment: 'Projekt Management',
      serverConnectionFailed: 'Serververbindung fehlgeschlagen',
      unknownError: 'Unbekannter Fehler, bitte später erneut versuchen',
    },

    action: {
      logIn: 'Einloggen',
    },
  },
};
